import { Map } from 'immutable';

import * as PaymentsConstants from '../constants';
import * as D from '../deps';

const INITIAL_STATE = Map({
  [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_ENTITLEMENT_ID]: '',
  [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_TIER]: '',
  [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_PARTNER_NAME]: '',
  [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_USER_CONFIRMED]: false,
});

export default D.createReducer(INITIAL_STATE, {
  [PaymentsConstants.Actions.INITIATE_PARTNER_UPGRADE]: onInitiatePartnerUpgrade,
  [PaymentsConstants.Actions.PARTNER_UPGRADE_CONFIRM_LISTENER]: onConfirmListener,
  [PaymentsConstants.Actions.EXIT_PARTNER_UPGRADE]: resetPartnerUpgrade,
  [D.Constants.Api.ApiActions.LOGOUT_SUCCESS]: resetPartnerUpgrade,
});

function onInitiatePartnerUpgrade(state, { payload: { entitlementId, tier, partnerName } }) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_ENTITLEMENT_ID]: entitlementId,
    [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_TIER]: tier,
    [PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_PARTNER_NAME]: partnerName,
  });
}

function onConfirmListener(state) {
  return state.set(PaymentsConstants.ReducerKeys.PARTNER_UPGRADE_USER_CONFIRMED, true);
}

function resetPartnerUpgrade() {
  return INITIAL_STATE;
}
